import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./config";
import { endpoints } from "./endpoints";

export const api = createApi({
  baseQuery,
  refetchOnMountOrArgChange: true,
  refetchOnFocus: true, // because of navigation.popToTop() after new entities creation
  tagTypes: [],
  endpoints(build) {
    return {
      generateCount: build.query({
        query: (id) => ({
          url: endpoints.generateCount(),
          method: "GET",
        }),
      }),
      getMealMeStore: build.query({
        query: (id) => ({
          url: endpoints.getMealMeStore(id),
          method: "GET",
        }),
      }),
      getMealMeStoresList: build.mutation({
        query: (data) => ({
          url: endpoints.getMealMeStoresList(),
          method: "POST",
          body: data,
        }),
      }),
      getDoordashStoresList: build.mutation({
        query: (data) => ({
          url: endpoints.getDoordashStoresList(),
          method: "POST",
          body: data,
        }),
      }),
      getMealMeMenuDownload: build.mutation({
        query: (data) => ({
          url: endpoints.getMealMeMenuDownload(),
          method: "POST",
          body: data,
        }),
      }),
      getDoordashMenuDownload: build.mutation({
        query: (data) => ({
          url: endpoints.getDoordashMenuDownload(),
          method: "POST",
          body: data,
        }),
      }),
      emailVerify: build.mutation({
        query: (data) => ({
          url: endpoints.emailVerify(),
          method: "POST",
          body: data,
        }),
      }),
    };
  },
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetMealMeMenuDownloadMutation,
  useLazyGetMealMeStoreQuery,
  useGetMealMeStoresListMutation,
  useEmailVerifyMutation,
  useGenerateCountQuery,
  useGetDoordashStoresListMutation,
  useGetDoordashMenuDownloadMutation,
} = api;
